import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "ant-design-vue/dist/antd.less";
import VueI18n from "vue-i18n";
import LangENUS from "./lang/en-us";
import LangZHCN from "./lang/zh-cn";
import globalComponents from "./components/index";
import moment from "moment";
import "moment/locale/zh-cn";
import 'babel-polyfill';
import VueVideoPlayer from 'vue-video-player';
import VueLazyload from 'vue-lazyload'
import '@/utils/sensors.js';

globalComponents();
// 卸载serviceWorker
Vue.use(VueVideoPlayer);
Vue.use(VueLazyload, {
  preLoad: 1,
  attempt: 2,
})
import * as serviceWorker from "./serviceWorker";
serviceWorker.unregister();
moment.locale("zh-cn");
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zh-cn",
  messages: {
    "en-us": LangENUS,
    "zh-cn": LangZHCN,
  },
});
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
